import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M.75 2.25a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v19.5a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5V2.25Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m5.25 17.25 3.462-4.616a1.5 1.5 0 0 1 2.261-.161L12 13.5l3.3-4.4a1.5 1.5 0 0 1 2.4 0l2.67 3.56",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.375 8.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M.75 17.25h22.5",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M.75%202.25a1.5%201.5%200%200%201%201.5-1.5h19.5a1.5%201.5%200%200%201%201.5%201.5v19.5a1.5%201.5%200%200%201-1.5%201.5H2.25a1.5%201.5%200%200%201-1.5-1.5V2.25Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22m5.25%2017.25%203.462-4.616a1.5%201.5%200%200%201%202.261-.161L12%2013.5l3.3-4.4a1.5%201.5%200%200%201%202.4%200l2.67%203.56%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M6.375%208.25a1.875%201.875%200%201%200%200-3.75%201.875%201.875%200%200%200%200%203.75Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M.75%2017.25h22.5%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
